import { FormControl, FormHelperText, Stack, StackProps, SxProps } from "@mui/material";
import { Theme } from "@mui/material/styles";

import { ValidationHelper } from "@/common/validation";

import DepartmentsAutocomplete from "../Department/DepartmentsAutocomplete";
import LocationsAutocomplete from "../Location/LocationsAutocomplete";

export interface EntityAffiliationInputPropsV2 {
  departments?: {
    departmentIds?: string[] | null;
    onChange?: (departmentIds: string[]) => void;
    error?: string;
  };
  locations?: {
    locationIds?: string[] | null;
    onChange?: (locationIds: string[]) => void;
    error?: string;
  };
  disabled?: boolean;
  stackProps?: StackProps;
  sx?: SxProps<Theme>;
}

export default function EntityAffiliationInputV2({
  departments,
  locations,
  disabled,
  stackProps,
  sx,
}: EntityAffiliationInputPropsV2) {
  return (
    <FormControl sx={sx} margin='dense' fullWidth>
      <Stack
        direction={{
          md: "column",
          xxs: "column",
        }}
        gap={{
          md: 0,
          xxs: 0,
        }}
        {...stackProps}
      >
        <FormControl margin='dense' fullWidth>
          <DepartmentsAutocomplete
            entities={undefined}
            entityIds={departments?.departmentIds}
            disabled={disabled}
            isPreload={false}
            onChange={(newDepartments) => {
              const ids = newDepartments?.map((d) => d.id!) || [];
              departments?.onChange?.(ids || []);
            }}
          />
          {departments?.error && (
            <FormHelperText error>
              {ValidationHelper.getFormikErrorsAsString(departments.error)}
            </FormHelperText>
          )}
        </FormControl>

        <FormControl margin='dense' fullWidth>
          <LocationsAutocomplete
            entities={undefined}
            entityIds={locations?.locationIds}
            disabled={disabled}
            isPreload={false}
            onChange={(newLocations) => {
              const ids = newLocations?.map((l) => l.id!) || [];
              locations?.onChange?.(ids || []);
            }}
          />
          {locations?.error && (
            <FormHelperText error>
              {ValidationHelper.getFormikErrorsAsString(locations.error)}
            </FormHelperText>
          )}
        </FormControl>
      </Stack>
    </FormControl>
  );
}
